<template>
  <div class="lend-container">
    <van-nav-bar :title="$t('lend_money')" left-arrow>
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="content-top">
        <div class="money-row">
          <div class="money-row-title">USDT</div>
          <div class="money-row-num">
            {{ lendMoney }}
          </div>
          <div
            class="money-row-btn"
            @click="(show = true), (dialogLendMoney = lendMoney)"
          >
            <img src="../../assets/lend-edit.png" alt="" />
          </div>
        </div>
        <div class="money-slider">
          <van-slider
            @change="amountChange"
            button-size="20px"
            :min="loanConfig[0].min_amount"
            :max="loanConfig[loanConfig.length - 1].max_amount"
            v-model="lendMoney"
            bar-height="16px"
            active-color="#0062f8"
          />
        </div>
        <div class="amount-row">
          <div class="amount-row-item">
            {{ loanConfig[0].min_amount }}
          </div>
          <div class="amount-row-item">
            {{ loanConfig[loanConfig.length - 1].max_amount }}
          </div>
        </div>
      </div>
      <div class="content-verify">
        <div class="title">
          {{ $t("verify_amount") }}
        </div>
        <div class="content-verify-row">
          <div class="row-left">
            {{ $t("verify_money") }}
          </div>
          <div class="row-right">
            USDT {{ lendMoney < 1000 ? 0 : verifyAmount }}
          </div>
        </div>
        <div class="content-verify-row">
          <div class="row-left">
            {{ $t("wallet_balance") }}
          </div>
          <div class="row-right">USDT {{ userInfo.address_usdt }}</div>
        </div>
        <div class="content-verify-row">
          <div class="row-left">
            {{ $t("need_to_add_amount") }}
          </div>
          <div class="row-right">
            USDT {{ needMoney < 0 || lendMoney < 1000 ? 0 : needMoney }}
          </div>
        </div>
      </div>
      <div class="content-month">
        <div class="title">
          {{ $t("loan_term_month") }}
        </div>
        <div class="content-month-list">
          <div
            class="content-month-list-item"
            @click="periodIndex = index"
            :class="index == periodIndex ? 'active' : ''"
            v-for="(item, index) in loanInfo.interest_rate"
            :key="item.period"
          >
            {{ item.period }}
          </div>
        </div>
      </div>
      <div class="content-detail">
        <div class="title">
          {{ $t("loan_amount_and_details") }}
        </div>
        <div class="content-detail-box">
          <div class="content-detail-box-row">
            <div class="row-left">
              {{ $t("total_interest_rate") }}
            </div>
            <div class="row-right">{{ totalRate.toFixed(4) }}%</div>
          </div>
          <div class="content-detail-box-row">
            <div class="row-left">
              {{ $t("monthly_interest") }}
            </div>
            <div class="row-right">USDT {{ interest.toFixed(4) }}</div>
          </div>
          <div class="content-detail-box-row">
            <div class="row-left">
              {{ $t("total_interest") }}
            </div>
            <div class="row-right">USDT {{ totalInterest.toFixed(4) }}</div>
          </div>
          <div class="content-detail-box-row">
            <div class="row-left">
              {{ $t("loan_start_and_end_dates") }}
            </div>
            <div class="row-right">
              <div class="time-item">
                {{ new Date().getTime() | dateFormat("dd-MM-yyyy") }}
              </div>
              <div class="time-item">
                {{ endTime }}
              </div>
            </div>
          </div>
          <div class="content-detail-box-row">
            <div class="row-left">
              {{ $t("date_of_first_renovation") }}
            </div>
            <div class="row-right">{{ firstDate }}</div>
          </div>
          <div class="content-detail-box-row">
            <div class="row-left">
              {{ $t("loan_term") }}
            </div>
            <div class="row-right">
              {{ loanInfo.interest_rate[periodIndex].period }}
            </div>
          </div>
          <div class="content-detail-box-policy">
            <van-checkbox
              shape="square"
              v-model="checked"
              @click="checked = true"
              >{{ $t("loan_agreee") }}
              <span @click.stop="goAgreement">{{
                $t("loan_agreeement")
              }}</span></van-checkbox
            >
          </div>
        </div>
      </div>
      <div
        class="content-btn"
        @click="loanApply"
        :style="{ background: '#0062f8' }"
      >
        {{ $t("loan_confirm") }}
      </div>
    </div>
    <van-dialog
      v-model="show"
      :title="$t('lend_money')"
      show-cancel-button
      @confirm="dialogConfirm"
    >
      <div class="dialog-box">
        <input type="text" v-model="dialogLendMoney" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Decimal from "decimal.js";
import Web3 from "web3";
import { Dialog } from "vant";
import tools from '@/utils/tools'


export default {
  data() {
    return {
      show: false,
      locale: "en",
      lendMoney: 0,
      loanInfo: "",
      verifyAmount: 0,
      needMoney: 0,
      userInfo: "",
      periodIndex: 0,
      checked: true,
      dialogLendMoney: 0,
      userAddress: "",
    };
  },
  created() {
    if (localStorage.getItem("app_token")) {
      this.getUserInfo();
    }
    if (this.I18n.locale.indexOf("zh") != -1) {
      this.locale = "zh";
    }
    this.dialogLendMoney = this.lendMoney;
    this.getLoanConfig();
    this.userAddress = localStorage.getItem("addData");
  },
  computed: {
    firstDate() {
      let date = new Date();
      if (date.getMonth() + 2 > 12) {
        if (date.getMonth() + 2 == 14) {
          if (date.getDate() == 29) {
            if (date.getFullYear() % 4 == 0) {
              return "29-02-" + (date.getFullYear() + 1);
            } else {
              return "28-02-" + (date.getFullYear() + 1);
            }
          } else {
            return date.getDate() + "-02-" + (date.getFullYear() + 1);
          }
        } else {
          return `${date.getDate()}-${date.getMonth() + 2 - 12}-${
            date.getFullYear() + 1
          }`;
        }
      } else {
        return `${date.getDate()}-${date.getMonth() + 2}-${
          date.getFullYear() + 1
        }`;
      }
    },
    totalRate() {
      return new Decimal(this.loanInfo.interest_rate[this.periodIndex].rate)
        .mul(100)
        .mul(new Decimal(this.loanInfo.interest_rate[this.periodIndex].period));
    },
    totalInterest() {
      return new Decimal(
        this.loanInfo.interest_rate[this.periodIndex].period
      ).mul(new Decimal(this.interest));
    },
    interest() {
      return new Decimal(this.lendMoney).mul(
        new Decimal(this.loanInfo.interest_rate[this.periodIndex].rate)
      );
    },
    endTime() {
      let date = new Date();
      let periodNum = this.loanInfo.interest_rate[this.periodIndex].period;
      if (date.getMonth() + +periodNum + 1 > 12) {
        if (date.getMonth() + +periodNum + 1 == 2) {
          if (date.getDate() == 29) {
            if (date.getFullYear() % 4 == 0) {
              return "29-02-" + (date.getFullYear() + 1);
            } else {
              return "28-02-" + (date.getFullYear() + 1);
            }
          } else {
            return (
              date.getDate() +
              "-" +
              (date.getMonth() + +periodNum + 1 - 12)
                .toString()
                .padStart(2, "0") +
              "-" +
              (date.getFullYear() + 1)
            );
          }
        } else {
          return (
            date.getDate() +
            "-" +
            (date.getMonth() + +periodNum + 1 - 12)
              .toString()
              .padStart(2, "0") +
            "-" +
            (date.getFullYear() + 1)
          );
        }
      } else {
        return (
          date.getDate() +
          "-" +
          (date.getMonth() + +periodNum + 1).toString().padStart(2, "0") +
          "-" +
          date.getFullYear()
        );
      }
    },
  },
  methods: {
    dialogConfirm() {
      this.lendMoney = this.dialogLendMoney;
      this.loanConfig.forEach((item) => {
        if (
          this.dialogLendMoney < item.max_amount &&
          this.dialogLendMoney >= item.min_amount
        ) {
          this.loanInfo = item;
          this.$set(this.loanInfo, "interest_rate", item.interest_rate);
          this.verifyAmount = new Decimal(this.lendMoney).mul(
            new Decimal(item.verify_rate)
          );
          this.needMoney = new Decimal(this.verifyAmount).sub(
            new Decimal(this.userInfo.address_usdt)
          );
        }
        if (
          this.dialogLendMoney ==
          this.loanConfig[this.loanConfig.length - 1].max_amount
        ) {
          this.loanInfo = item;
          this.$set(this.loanInfo, "interest_rate", item.interest_rate);
          this.verifyAmount = new Decimal(this.lendMoney).mul(
            new Decimal(item.verify_rate)
          );
          this.needMoney = new Decimal(this.verifyAmount).sub(
            new Decimal(this.userInfo.address_usdt)
          );
        }
      });
    },
    goAgreement() {
      this.$router.push(
        `/agreement/${this.loanInfo.interest_rate[this.periodIndex].period}/${
          this.lendMoney
        }`
      );
    },
    async getUserInfo() {
      const res = await this.$api.getUserInfo();
      if (res.code == 200) {
        this.userInfo = res.data;
        localStorage.setItem("userInfo", JSON.stringify(res.data));
      }
    },
    async loanApply() {
      if (!this.checked) {
        this.$Dialog.alert({
          message: "please read and agree the agreement",
          confirmButtonText: "confirm",
        });
        return;
      }
      this.$router.push(
        `/sign/${this.loanInfo.interest_rate[this.periodIndex].period}/${
          this.lendMoney
        }`
      );
    },
    amountChange(e) {
      this.dialogLendMoney = e;
      this.loanConfig.forEach((item) => {
        if (e < item.max_amount && e >= item.min_amount) {
          this.loanInfo = item;
          this.$set(this.loanInfo, "interest_rate", item.interest_rate);
          this.verifyAmount = new Decimal(this.lendMoney).mul(
            new Decimal(item.verify_rate)
          );
          this.needMoney = new Decimal(this.verifyAmount).sub(
            new Decimal(this.userInfo.address_usdt)
          );
        }
        if (e == this.loanConfig[this.loanConfig.length - 1].max_amount) {
          this.loanInfo = item;
          this.$set(this.loanInfo, "interest_rate", item.interest_rate);
          this.verifyAmount = new Decimal(this.lendMoney).mul(
            new Decimal(item.verify_rate)
          );
          this.needMoney = new Decimal(this.verifyAmount).sub(
            new Decimal(this.userInfo.address_usdt)
          );
        }
      });
    },
    navBack() {
      this.$router.go(-1);
    },
    async getLoanConfig() {
      const res = await this.$api.getLoanConfig();
      if (res.code == 200) {
        this.loanConfig = res.data;
        this.loanInfo = res.data[res.data.length - 1];
        this.lendMoney = res.data[res.data.length - 1].max_amount;
        this.verifyAmount = new Decimal(
          res.data[res.data.length - 1].max_amount
        ).mul(new Decimal(res.data[res.data.length - 1].verify_rate));
        this.needMoney = new Decimal(this.verifyAmount).sub(
          new Decimal(this.userInfo.address_usdt)
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lend-container {
  .back {
    width: 30px;
    height: 15px;
  }
  .content {
    padding: 15px;
    &-top {
      background: #fff;
      padding: 15px 20px;
      .money-row {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        &-title {
          margin-right: 3px;
        }
        &-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 20px;
            height: 20px;
            margin-left: 5px;
          }
        }
      }
      .money-slider {
        margin-top: 20px;
      }
      .amount-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
      }
    }
    .title {
      font-size: 20px;
      font-weight: 600;
    }
    &-verify {
      background: #fff;
      padding: 15px 20px;
      margin-top: 20px;
      &-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 5px;
        &:first-child {
          margin-top: 10px;
        }
      }
    }
    &-month {
      background: #fff;
      padding: 15px 20px;
      margin-top: 20px;
      &-list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 20px;
        &-item {
          width: 20%;
          margin-right: 16px;
          margin-bottom: 10px;
          padding: 10px 0;
          font-size: 14px;
          text-align: center;
          border: 1px solid #000;
          border-radius: 5px;
          &:nth-child(4n) {
            margin-right: 0;
          }
        }
        .active {
          background: #0062f8;
          color: #fff;
          border-color: #0062f8;
        }
      }
    }
    &-detail {
      background: #fff;
      padding: 15px 20px;
      margin-top: 20px;
      &-box {
        margin-top: 20px;
        &-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: 14px;
        }
        &-policy {
          font-size: 14px;
          margin-top: 10px;
          span {
            color: #0062f8;
          }
        }
      }
    }
    &-btn {
      background: #0062f8;
      width: 95%;
      margin: 0 auto;
      margin-top: 20px;
      color: #fff;
      font-size: 16px;
      text-align: center;
      padding: 15px 0;
      border-radius: 50px;
      font-weight: 600;
    }
  }
  .dialog-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    input {
      flex: 1;
      padding: 10px 0;
      border: none;
      border-bottom: 1px solid #000;
    }
  }
}
</style>